import { useState } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import { IoMdCheckmark } from 'react-icons/io'
import ButtonSponsorRegister from './sponsor-packages-page/ButtonSponsorRegister'
import { useTranslation } from 'react-i18next'

export default function SponsorPackageFooter({ yearPrice, hanlfYearPrice, sponsor_package_id, sold, duration, setDuration }) {
  const [isOpen, setisOpen] = useState(false)
  const { t } = useTranslation()
  function handleOnClickTaggleFooter() {
    setisOpen(!isOpen)
  }

  const calculatePriceAfterDiscount = (price, soldPercentage) => {
    const discountAmount = price * (soldPercentage / 100)
    const discountedPrice = price - discountAmount

    return discountedPrice.toFixed(2)
  }

  return (
    <div className="flex flex-col gap-2">
      <button
        onClick={handleOnClickTaggleFooter}
        className="flex items-center justify-between w-full px-4 py-2 border-2 border-muted-300 bg-muted-100"
      >
        <span className="text-lg font-semibold">{t('sponsorship_amount_and_duration')}</span>
        <FaChevronDown className={`transition-transform duration-300 ${isOpen ? 'rotate-0' : '-rotate-90'}`} />
      </button>
      {isOpen && (
        <div className="grid grid-cols-12 gap-2 text-sm">
          <button
            onClick={() => setDuration('YEAR')}
            className="relative col-span-6 p-2 pb-5 border-2 border-muted-300"
          >
            <div className="flex items-center gap-2">
              <label
                htmlFor="ID_DURATION_YEAR"
                className={`flex h-4 w-4 items-center justify-center border-2 ${duration === 'YEAR' ? 'border-primary-600 bg-primary-600 text-white' : 'border-muted-300 bg-muted-100 text-muted-100'} `}
              >
                <IoMdCheckmark
                  size={16}
                  strokeWidth={1.2}
                />
              </label>
              <p>{t('one_year')}</p>
            </div>
            {sold != 0 ? (
              <div className="flex flex-col items-center justify-center">
                <p className="text-xl font-bold line-through text-danger-600">${yearPrice}</p>
                <p className="text-3xl font-black text-secondary-600">${calculatePriceAfterDiscount(yearPrice, sold)}</p>
              </div>
            ) : (
              <div>
                <p className="text-2xl font-bold text-yellow-600">{yearPrice}$</p>
              </div>
            )}
          </button>
          <button
            onClick={() => setDuration('HALF_YEAR')}
            className="relative col-span-6 p-2 pb-5 border-2 border-muted-300"
          >
            <div className="flex items-center gap-2">
              <label
                htmlFor="ID_DURATION_YEAR"
                className={`flex h-4 w-4 items-center justify-center border-2 ${duration === 'HALF_YEAR' ? 'border-primary-600 bg-primary-600 text-white' : 'border-muted-300 bg-muted-100 text-muted-100'} `}
              >
                <IoMdCheckmark
                  size={16}
                  strokeWidth={1.2}
                />
              </label>
              <p>{t('six_months')}</p>
            </div>

            {sold != 0 ? (
              <div className="flex flex-col items-center justify-center">
                <p className="text-xl font-bold line-through text-danger-600">${hanlfYearPrice}</p>
                <p className="text-3xl font-black text-secondary-600">${calculatePriceAfterDiscount(hanlfYearPrice, sold)}</p>
              </div>
            ) : (
              <div>
                <p className="text-2xl font-bold text-yellow-600">{hanlfYearPrice}$</p>
              </div>
            )}
          </button>
        </div>
      )}
      <ButtonSponsorRegister
        duration={duration}
        sponsor_package_id={sponsor_package_id}
      />
    </div>
  )
}
